'use client'

import { useGetUserPreferences } from '@repo/bullmq-admin-data-provider/user-preferences/user-preferences'
import { useTranslate } from '@repo/shared-locales/locales/use-locales'
import { useEffect } from 'react'
import { allLangs } from '@repo/shared-locales/locales/all-langs'
import type { LanguageValue } from '@repo/shared-locales/locales/locales-config'
import { useSession } from 'next-auth/react'

export function SetI18nFromUserPreferences() {
  const { data: session } = useSession()
  const { data: userPreferences, isLoading } = useGetUserPreferences({ enabled: !!session?.user?.id })
  const { onChangeLang, currentLang } = useTranslate()

  useEffect(() => {
    /**
     * Do nothing if still loading or if no language is set in user preferences
     */
    if (!session?.user?.id || isLoading || !userPreferences?.language) {
      return
    }

    /**
     * Check if the currently set app language is in sync with user preferences
     */
    const isInSync = currentLang?.value === userPreferences?.language
    // console.log(`isInSync: ${isInSync} | currentLang: `, currentLang, ' | userPreferences.language: ', userPreferences?.language)

    /**
     * Do nothing if the language is already in sync
     */
    if (isInSync) {
      return
    }

    /**
     * If out of sync, Try to find the matching locale in allLangs
     */
    const foundLang = allLangs?.find(lang => lang?.value === userPreferences?.language)

    /**
     * If not found, log an error and return
     */
    if (!foundLang) {
      console.error(`Language ${userPreferences?.language} not found in allLangs, not able to set i18n locale from User Preferences`)
      return
    }

    /**
     * If found, change the app i18n locale to what was set in User Preferences.
     */
    console.log('foundLang: ', foundLang, ' | running onChangeLang to update i18n locale from User Preferences')
    onChangeLang(foundLang?.value as LanguageValue, false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userPreferences?.language])

  return <></>
}
